<template>
    <div class="queues ui-table scroll-color">
        <table class="table">
            <thead>
                <tr class="pl5">
                    <th/>
                    <th>Fila</th>
                    <th>Código</th>
                    <th>Label</th>
                    <th/>
                </tr>
            </thead>

            <tbody>
                <ui-whatsapp-script-table-item
                    v-for="(item, index) in leadList"
                    :key="index"
                    :index="index"
                    :leads="leads"
                />
            </tbody>

            <tfoot>
                <tr>
                    <td class="actions" colspan="5">
                        <ui-button
                            :loading="buttonLoading"
                            :disabled="cantGenerateCode"
                            design="success md"
                            @click="submit()"
                        >
                            <em class="fal fa-cog"/> Gerar Código
                        </ui-button>
                        <ui-button design="primary md" @click="addEmptyItem">
                            <em class="fal fa-plus"/> Adicionar Fila
                        </ui-button>
                    </td>
                </tr>
            </tfoot>
        </table>
    </div>
</template>

<script>
	import { uiButton } from '@/components/ui/buttons'

	import { storage } from '@/services/storage'
	import { tokens, lead } from '@/services/axios'

	import { mapGetters, mapActions } from 'vuex'

	import helpers from '@/mixins/helpers'

	import uiWhatsappScriptTableItem from '../whatsapp-script-to-link-table-item'

	export default {
		name: 'ui-whatsapp-script-table',

		components: {
			uiButton,
			uiWhatsappScriptTableItem,
		},

		mixins: [helpers],

		props: {
			plusSalutatinoButton: {
				type: Array,
				required: true,
			},
		},

		data() {
			return {
				leads: [],
				buttonLoading: false,
				apiConfig: JSON.parse(storage.get('api_config')),
			}
		},

		methods: {
			...mapActions('whatsapp', {
				addItem: 'addLead',
				setLead: 'setLead',
				clearLeads: 'clearLead',
			}),
			/**
			 * Gera o código com o Script necessário para a integração com o WhatsApp
			 */
			submit: async function () {
				try {
					this.buttonLoading = true
					const response = await tokens.getAll('integration/whatsapp', {})
					const code = `
						<script src="${this.mountScriptAddress()}"><\/script>
						<whatsapp-lead-capture
							instance="${this.apiConfig.instance}"
							token="${response.data.token_platform}"
							token-user="${response.data.token_user}"
							alert-messages="${this.mountAlertMessages()}"
							multi-channels="${this.mountMultiChannels()}"
						/>
					`
					this.$emit('input', code)

				} catch (error) {
					if (error?.data?.msg) this.$toastr.e(error.data.msg)

				} finally {
					this.buttonLoading = false
				}
			},

			// O script deve ficar no CDN
			mountScriptAddress() {
				const cdn = process.env.VUE_APP_CDN
				return cdn + 'static/facilita-whatsapp/whatsapp-lead-capture.min.js'
			},

			mountMultiChannels() {
				let leadListCopy = [...this.leadList]
				let array = []

				leadListCopy.map((item) => {
					delete item.index
					
					if (item.id && item.name && item.label)
						array.push(JSON.stringify(item).replace(/"/g, "'"))
				})

				return array.join('//')
			},

			mountAlertMessages() {
				let array = []

				// monta o array
				this.plusSalutatinoButton.map((res) => {
					array.push(res.value)
				})

				// remove  os valores que estão vazios
				array.map((val, i) => {
					if (val == '') {
						// verifica o indice do array se é vazio remove caso for
						array.splice(i, 1)
					}
				})

				// monta o array para a saudação do chat WhatsApp
				return array.join('//')
			},

			addEmptyItem() {
				this.addItem({
					index: null,
					id: null,
					name: null,
					label: null,
				})
			},

			formatLeadResponse(response) {
				this.clearLeads()

				this.leads = response.data.data.map((e) => {
					return {
						id: e.lead_id,
						name: e.lead_name,
						label: e.lead_name,
					}
				})

				this.$nextTick(() => {
					if (this.leads.length) this.addEmptyItem()
				})
			},
		},

		mounted() {
			this.$root.$on('modal-open-marketing-queues-multiple-lead-form-code', () => {
				lead.dataTable({
					page: 1,
					perPage: 100,
					search: '',
					filter: [
						{
							name: 'lead_type',
							value: 'whatsapp',
						},
					],
				})
					.then((response) => {
						this.formatLeadResponse(response)
					})
					.catch((error) => {
						if (error.data && error.data.msg) this.$toastr.e(error.data.msg)
					})
			})
		},

		computed: {
			...mapGetters('whatsapp', {
				leadList: 'getAll',
			}),

			cantGenerateCode() {
				return !this.leads.length || this.mountAlertMessages() == '' ? true : false
			},
		},

		beforeDestroy() {
			this.$root.$off('modal-open-marketing-queues-multiple-lead-form-code')
		},
	}
</script>

<style lang="stylus" scoped>
	@import 'styles.styl'
</style>
